import { childElements, forEachElement, isAppEnvironment } from "../util/Utils";
import { filterSheetButton, sheetContent } from "./Selectors";
import { registerClickTracker, sanFoldoutDeprecated } from "./FilterSheetTracking";
import { eventQBus } from "../types/EventQBus";
import FilterNavigationSheet, { LOCAL_NAVIGATION } from "./FilterNavigationSheet";
import FilterDetailSheet from "./FilterDetailSheet";
import type { SheetCloseTypes } from "@otto-ec/global-pattern/pattern/700_Layer_und_Popup/400_pl_sheet/sheetEvents";
import FilterSheet, { SIDEBAR_CHANGE_TRACKING_LABELS } from "./FilterSheet";
import { setActiveConfiguration } from "@otto-ec/heureka-components/filter";
import { readLegacyLabel } from "../tracking/FeatureTracking";
import { isMobile } from "../util/Breakpoint";

function closeAllTooltips(sheetContent: HTMLElement) {
  /*                                                                                          */
  forEachElement(
    ".pl_tooltip--bottom .pl_icon",
    (tooltip) => tooltip.dispatchEvent(new Event("click", { bubbles: true })),
    sheetContent,
  );
}

function closeAllTooltipsListener(event: Event) {
  const target = event.target as HTMLElement;
  const currentTarget = event.currentTarget as HTMLElement;
  if (!target.closest(".pl_tooltip--bottom")) {
    closeAllTooltips(currentTarget.parentElement || currentTarget);
  }
}

function fixSheet(element?: HTMLElement, additionalClass?: string) {
  element?.addEventListener("click", closeAllTooltipsListener, { capture: true, passive: true });
  element?.classList.add("heureka_filterSheet");
  element?.classList.add(additionalClass);
}

export function createSheetTemplate(
  content: HTMLElement | HTMLElement[] | null,
  menuSource: HTMLElement | null,
  showBackButton?: boolean,
  title?: string,
) {
  if (content) {
    const initialMobileHeight = isAppEnvironment() ? "90vh" : "80vh";
    const sheet = new window.o_global.pali.sheet({
      title,
      /*                                             */
      content: content as unknown as string,
      menuContent: (childElements(menuSource) || []) as unknown as string,
      showBackButton,
      fullBleedContent: true,
      initialMobileHeight,
      openCallback: openCallback,
      closeCallback: closeCallback,
      createTrackingContext: false,
    });

    fixSheet(sheet.getTitle());
    fixSheet(sheet.getContent());
    fixSheet(sheet.getMenuBar(), "heureka_filterSheet__menu-bar");
    return sheet;
  }
}

function openCallback() {
  const elem = sheetContent();
  const { filterId } = elem?.dataset || {};

  registerClickTracker(".pl_sheet", {
    capture: true,
    passive: true,
  });

  eventQBus.emit("ftfind.filterSheet.opened", {
    filterId,
  });
}

/**
 *
 */
function closeCallback(params: { closeType: SheetCloseTypes }) {
  /*                                                                                            */
  const content = sheetContent();
  const { filterId, tsLabels = "{}" } = content?.dataset || {};

  if (filterId) {
    switch (filterId) {
      case LOCAL_NAVIGATION:
        FilterNavigationSheet.declare().deactivate();
        break;
      default:
        /*                                                                                         */
        /*                                                                                                          */
        FilterDetailSheet.declare(filterId)
          .submitFilter(params.closeType === "closedProgrammatically" ? "view_selection" : params.closeType)
          .deactivate(SIDEBAR_CHANGE_TRACKING_LABELS);
    }
  } else {
    FilterSheet.declare().deactivate(SIDEBAR_CHANGE_TRACKING_LABELS);
  }
  /*                                                                                             */
  setActiveConfiguration(isMobile() ? "sheetFirstLevel" : "default");
  const san_FilterWhatIf = readLegacyLabel(filterSheetButton(), "san_FilterWhatIf");
  return eventQBus.emit("ftfind.filterSheet.closed", {
    filterId,
    tracking: {
      san_Foldout: sanFoldoutDeprecated(params.closeType),
      san_FilterWhatIf,
      ...JSON.parse(tsLabels),
    },
  });
}

function nextBestFiltercloseCallback(params: { closeType: SheetCloseTypes }) {
  /*                                                                                            */
  const content = sheetContent();
  const { filterId, tsLabels = "{}" } = content?.dataset || {};

  if (filterId) {
    /*                                                                                                          */
    /*                                                                                         */
    const filterDetailSheet = FilterDetailSheet.declare(filterId);
    if (!content?.classList?.contains("heureka_filterSheet--onSubmission")) {
      /*                        */
      filterDetailSheet.submitFilter(
        params.closeType === "closedProgrammatically" ? "view_selection" : params.closeType,
      );
    }
    filterDetailSheet.deactivate(SIDEBAR_CHANGE_TRACKING_LABELS);
  } else {
    FilterSheet.declare().deactivate(SIDEBAR_CHANGE_TRACKING_LABELS);
  }
  /*                                                                                             */
  setActiveConfiguration(isMobile() ? "sheetFirstLevel" : "default");
  const san_FilterWhatIf = readLegacyLabel(filterSheetButton(), "san_FilterWhatIf");
  return eventQBus.emit("ftfind.filterSheet.closed", {
    filterId,
    tracking: {
      san_Foldout: sanFoldoutDeprecated(params.closeType),
      san_FilterWhatIf,
      ...JSON.parse(tsLabels),
    },
  });
}

/*                     */
export function createNextBestFilterSheet(
  content: HTMLElement | HTMLElement[] | null,
  menuSource: HTMLElement | null,
  title?: string,
) {
  if (content) {
    const sheet = new window.o_global.pali.sheet({
      title,
      /*                                             */
      content: content as unknown as string,
      menuContent: (childElements(menuSource) || []) as unknown as string,
      showBackButton: false,
      fullBleedContent: true,
      openCallback: openNextBestFilterCallback,
      closeCallback: nextBestFiltercloseCallback,
      createTrackingContext: false,
      lockMobileHeight: false,
    });

    fixSheet(sheet.getTitle());
    fixSheet(sheet.getContent(), "heureka_filterSheet--nbf");
    fixSheet(sheet.getMenuBar(), "heureka_filterSheet__menu-bar");
    return sheet;
  }
}

function openNextBestFilterCallback() {
  registerClickTracker(".pl_sheet", {
    capture: true,
    passive: true,
  });
}
